
import Firebase from 'firebase'
let config = {
  apiKey: "AIzaSyAMz_qba0EYhI5ebjb94gmy11cawzLvYeQ",
  authDomain: "doitcare-3c771.firebaseapp.com",
  databaseURL: "https://doitcare-3c771.firebaseio.com",
  projectId: "doitcare-3c771",
  storageBucket: "doitcare-3c771.appspot.com",
  messagingSenderId: "145121590793",
  appId: "1:145121590793:web:07084ca37b82dc553442d8",
  measurementId: "G-LG6GCLW6NG"
};

  export default !Firebase.apps.length ? Firebase.initializeApp(config) : Firebase.app();
  export const db =  !Firebase.apps.length ? Firebase.initializeApp(config) : Firebase.firestore();
  export const firestorage =  !Firebase.apps.length ? Firebase.initializeApp(config) : Firebase.storage();
  export const firestore = !Firebase.apps.length ? Firebase.initializeApp(config) : Firebase.firestore();